// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-3JYY2";
var _3 = "footer-2O1lJ";
export { _1 as "__esModule", _2 as "content", _3 as "footer" }
export default { "__esModule": _1, "content": _2, "footer": _3 }
